import { useTranslation } from "@redotech/redo-i18n";
import AiStarIcon from "@redotech/redo-icons/ai-star.svg";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { memo, useContext } from "react";
import * as styles from "./ask-redo-button.module.css";

interface AskRedoButtonProps {
  onClick: () => void;
}

// Inside joke for CboysTv
const ASK_JEFF_TEAM_ID = "69b2d794138a74d220d1f691";

const OrangeAiStarIcon = () => <AiStarIcon className={styles.icon} />;

export function useAskRedoButtonText(): string {
  const { t } = useTranslation();
  const team = useContext(TeamContext);
  const assistantName =
    team?._id.toString() === ASK_JEFF_TEAM_ID ? "Jeff" : "Redo";
  return t("Ask {{assistantName}}", {
    assistantName,
    context: "button that opens the named AI assistant",
  });
}

export const AskRedoButton = memo(function AskRedoButton({
  onClick,
}: AskRedoButtonProps) {
  const text = useAskRedoButtonText();

  return (
    <RedoButton
      buttonClassName={styles.button}
      className="dark-mode"
      hierarchy="secondary"
      IconLeading={OrangeAiStarIcon}
      onClick={onClick}
      size="sm"
      text={text}
    />
  );
});
